// src/components/products/sensaphone/SensaphoneFeatures.jsx
import React from "react";
import RichTextRenderer from "../../common/RichTextRenderer";
import ProductContainerImage from "../ProductContainerImage";
import {
  PRODUCT_DETAIL_BODY_TEXT,
  PRODUCT_DETAIL_CONTENT_WRAP,
} from "../../../utils/productDetailTypography";

const SensaphoneFeatures = ({ title, features, safeText, onMediaClick }) => {
  if (!title || !features || !features[0]) return null;

  const main = features[0];

  const hasMedia =
    main.youtube_id || (main.media && main.media.length > 0);

  const renderContent = () => {
    if (!main.content) return null;

    if (Array.isArray(main.content)) {
      return (
        <RichTextRenderer
          content={main.content}
          textColorClass="text-gray-800"
          linkColorClass="text-blue-600 hover:text-blue-800 underline text-lg lg:text-xl"
          bodyTextClass={PRODUCT_DETAIL_BODY_TEXT}
          compactHeadings
        />
      );
    }

    return (
      <div
        className={`${PRODUCT_DETAIL_BODY_TEXT} whitespace-pre-line text-gray-700`}
      >
        {safeText(main.content)}
      </div>
    );
  };

  const renderMedia = () => {
    if (main.youtube_id) {
      return (
        <div className="relative w-full aspect-video bg-black rounded-xl overflow-hidden shadow-lg">
          <iframe
            src={`https://www.youtube.com/embed/${main.youtube_id}`}
            title={safeText(main.title) || "YouTube video"}
            className="w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      );
    }

    if (main.media && main.media.length > 0) {
      return (
        <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
          {main.media.map((mediaItem, mediaIndex) => {
            const mediaUrl = mediaItem?.url;
            if (!mediaUrl) return null;

            const altText = safeText(
              mediaItem?.alternativeText ||
                mediaItem?.alt ||
                mediaItem?.name ||
                safeText(main.title) ||
                `Media ${mediaIndex + 1}`
            );

            return (
              <ProductContainerImage
                sizing="intrinsic"
                key={mediaItem.id || mediaIndex}
                src={mediaUrl}
                alt={altText}
                className="cursor-zoom-in transition-transform duration-200 hover:scale-[1.02]"
                onClick={() => {
                  if (!onMediaClick) return;
                  onMediaClick({
                    type: "photo",
                    title: altText,
                    imageUrl: mediaUrl,
                  });
                }}
              />
            );
          })}
        </div>
      );
    }

    return null;
  };

  return (
    <div className="mb-12 md:mb-16">
      <div className="product-panel-elevated rounded-3xl shadow-2xl overflow-hidden">
        {/* Features Title Bar */}
        <div className="product-panel-header">
          <h2>
            {safeText(title)}
          </h2>
        </div>

        {/* Features Content */}
        <div className="p-6 sm:p-8 lg:p-10">
          {main.title && (
            <h3 className="text-lg sm:text-xl md:text-2xl leading-tight font-bold text-gray-900 mb-6 md:mb-8">
              {safeText(main.title)}
            </h3>
          )}

          {hasMedia ? (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-12">
              {/* Left: Content */}
              <div className={PRODUCT_DETAIL_CONTENT_WRAP}>
                {renderContent()}
              </div>

              {/* Right: Media or YouTube */}
              <div className="flex items-center justify-center">
                {renderMedia()}
              </div>
            </div>
          ) : (
            <div className={PRODUCT_DETAIL_CONTENT_WRAP}>
              {renderContent()}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SensaphoneFeatures;





